<template>
  <div>
    <div v-show="loading" class="flex justify-center mt3 textColor">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <track-download v-show="!loading" :purchasedTracks="myShopping" :withFilters="false" :withPagination="false"
                 :loading="loading"></track-download>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import TrackDownload from '@/components/tracks/TrackDownload.vue'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    name: 'my-shopping',
    components: {
      TrackDownload,
      ClipLoader
    },
    data () {
      return {
        color: '#808080',
        size: '30px'
      }
    },
    created () {
      this.getMyShopping().catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
    },
    computed: {
      ...mapGetters('user', [
        'error',
        'loading',
        'myShopping'
      ])
    },
    methods: {
      ...mapActions('user', [
        'getMyShopping'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/MyShopping.vue